import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	Button,
	Space,
	notification,
	Result,
	Tooltip,
	Skeleton,
} from 'antd';
import { XLottie } from '../Login/LoginStyle';
import { useNavigate, useParams } from 'react-router-dom';
import Thanks from '../../json/thanksNew1.json';
import {
	XContainer,
	XForm,
	XThemeModal,
	XAffix,
	XThemeInputText,
} from '../../styles/GlobalThemeStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import {
	XAddCodeSticky,
	XThemeCardCaseOperations,
	XThemeAvatarName,
	XThemeAddressWrap,
	XThemeAvatarText,
} from '../CaseForm/CaseFormStyle';
import {
	XLottieMargin,
	XPara1,
	XButtonCloseBar,
	XButtonReload,
	XNotificationBar,
	XButtonConfirm,
} from '../AnalyseCoverage/AnalyseCoverageStyle';
import {
	WarningOutlined,
	UserOutlined,
	CloseOutlined,
} from '@ant-design/icons';
// Actions
import {
	analyseCoverageApi,
	analyseCoverageReset,
} from '../../actions/analyseCoverageAction';
import {
	reviseCoverageApi,
	reviseCoverageReset,
} from '../../actions/reviseCoverageAction';
import {
	sendFeedbackApi,
	sendFeedbackReset,
} from '../../actions/sendFeedbackAction';
import {
	getAnalysisApi,
	getAnalysisReset,
} from '../../actions/getAnalysisAction';
import { editCaseApi, editCaseReset } from '../../actions/editCaseAction';
import { checkModulePermissions, toTitleCase } from '../../utils/helper';
import moment from 'moment';
import Header from '../../components/Header/Header';
import AnalysisLoader from '../../components/AnalysisLoader/AnalysisLoader';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import dayjs from 'dayjs';
import {
	getIcdCodesApi,
	getIcdCodesReset,
} from '../../actions/getIcdCodesAction';
import CaseOperations from '../../components/HorizontalTimeline/CaseOperations';
import {
	getCptCodesApi,
	getCptCodesReset,
} from '../../actions/getCptCodesAction';
import DrawerCodingTools from '../../components/CodingTools/DrawerCodingTools';
import {
	XTheme2MainTitle2,
	XTheme2TableCircleTag,
} from '../../styles/GlobalThemeStyleCQ';

const CaseAnalysisView = (props) => {
	const {
		analyseCoverage,
		analyseCoverageReset,
		analyseCoverageState,
		reviseCoverage,
		reviseCoverageReset,
		reviseCoverageState,
		sendFeedback,
		sendFeedbackReset,
		sendFeedbackState,
		getAnalysis,
		getAnalysisState,
		getAnalysisReset,
		editCaseReset,
		editCaseState,
		editCase,
		collapsed,
	} = props;
	const navigate = useNavigate();
	const missingFieldsCardRef = useRef(null);
	const id = useParams().id;
	const [form] = XForm.useForm();
	const [summaryForm] = XForm.useForm();
	const [newOptionForm] = XForm.useForm();
	const [missingFieldsForm] = XForm.useForm();
	const [loading, setLoading] = useState(false);
	const [modalOpen, setModalOpen] = useState([false, '', '', '', '']);
	const [thanksModal, setThanksModal] = useState([false, '']);
	const [missingFieldsModal, setMissingFieldsModal] = useState(false);
	const [missingFields, setMissingFields] = useState([]);
	const [missingFieldInstructions, setMissingFieldInstructions] = useState(
		[],
	);
	const [missingFieldTitle, setMissingFieldTitle] = useState('');
	const [lastAnalysisData, setLastAnalysisData] = useState({});
	const [showAnalysisData, setShowAnalysisData] = useState(false);
	const [patientData, setPatientData] = useState({});
	const [modalTextArea, setModalTextArea] = useState('');
	const [feedbackId, setFeedbackId] = useState(null);
	const [matchGender, setMatchGender] = useState(true);
	const [pageContent, setPageContent] = useState({
		pastHistory: [],
		presentComplaint: [],
		recommendedProcedure: [],
		medicalCoverage: [],
		status: '',
		missing_points_for_coverage: [],
	});
	const [newOptionText, setNewOptionText] = useState('');
	const [newCheckBoxModal, setNewCheckBoxModal] = useState([false, null]);
	const [analysisCompleted, setAnalysisCompleted] = useState('');
	const [isMissingFieldsThere, setIsMissingFieldsThere] = useState(false);
	const [previewOpen, setPreviewOpen] = useState(false);
	const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
	const [previewImage, setPreviewImage] = useState('');
	const [previewTitle, setPreviewTitle] = useState('');
	const [clinicalDocumentsToDisplay, setClinicalDocumentsToDisplay] =
		useState([]);
	const [clinicalDocsForm] = XForm.useForm();
	const [formData, setFormData] = useState({});
	const [showClinicalTextArea, setShowClinicalTextArea] = useState(false);
	const [documentsToDisplay, setDocumentsToDisplay] = useState([]);
	const [isClinicalUploadModalOpen, setIsClinicalUploadModalOpen] =
		useState(false);
	const [clinicalDocsLoading, setClinicalDocsLoading] = useState(false);
	const [clinicalDocumentFileList, setClinicalDocumentFileList] = useState(
		[],
	);
	const [
		updatedClinicalDocumentFileList,
		setUpdatedClinicalDocumentFileList,
	] = useState([]);
	const [clinicalSummaryTextLoading, setClinicalSummaryTextLoading] =
		useState(false);
	const [coverageloading, setCoverageLoading] = useState(false);
	const [submitClinicalDocs, setSubmitClinicalDocs] = useState(false); // Initial value can be 'textarea' or 'upload'
	// State for holding filters
	const [icdform] = XForm.useForm();
	const [cptform] = XForm.useForm();
	const [openIcdCptDrawer, setOpenIcdCptDrawer] = useState(false);
	const [openIcdCptDrawer2, setOpenIcdCptDrawer2] = useState(false);
	const [activeCode, setActiveCode] = useState(null);
	const [icdFilters, setIcdFilters] = useState({
		search: '',
		loaded_count: 0,
		limit: 10,
		related: false,
		childCode: '',
	});
	const [icdCodes, setIcdCodes] = useState([]); // To store fetched ICD codes
	const [icdLoading, setIcdLoading] = useState(false); // To manage loading state
	const [searchResults, setSearchResults] = useState([]); // To store search results
	const [triggeredBySearch, setTriggeredBySearch] = useState(false); // To track search-triggered calls
	const [triggeredByEnter, setTriggeredByEnter] = useState(false); // To track search-triggered calls
	const [loadMore, setLoadMore] = useState(false); // To track search-triggered calls
	const [icdSearchLoading, setIcdSearchLoading] = useState(false); // To manage loading state
	const [LooksGoodLoading, setLooksGoodLoading] = useState(false);
	//CPT Codes
	const [cptFilters, setCptFilters] = useState({
		search: '',
		loaded_count: 0,
		limit: 10,
	});
	const [cptCodes, setCptCodes] = useState([]); // To store fetched ICD codes
	const [cptLoading, setCptLoading] = useState(false); // To manage loading state
	const [cptSearchResults, setCptSearchResults] = useState([]); // To store search results
	const [cptTriggeredBySearch, setCptTriggeredBySearch] = useState(false); // To track search-triggered calls
	const [cptTriggeredByEnter, setCptTriggeredByEnter] = useState(false); // To track search-triggered calls
	const [cptLoadMore, setCptLoadMore] = useState(false); // To track search-triggered calls
	const [cptSearchLoading, setCptSearchLoading] = useState(false); // To manage loading state
	// State to track the "fixed" prop value
	const [caseClosed, setCaseClosed] = useState(false);
	const [mainDataLoading, setMainDataLoading] = useState(true);
	const [currentRevision, setCurrentRevision] = useState(null);

	useEffect(() => {
		if (modalOpen[0] && modalOpen[4] !== 'feedbackSummary') {
			// Check if modal is open and it's not the feedbackSummary modal
			const [description, code] = modalTextArea.split(' - ');
			form.setFieldsValue({
				modal_text_area: description || '', // Prepopulate description
				code: code ? code.split(': ')[1] : '', // Extract and prepopulate code
			});
		}
	}, [modalOpen, modalTextArea, form]);

	// Coding tools Add this useEffect to handle tab switching
	const [activeTab, setActiveTab] = useState('1');
	// Add new state variables to track drawer states separately
	const [openIcdDrawer, setOpenIcdDrawer] = useState(true);
	const [openCptDrawer, setOpenCptDrawer] = useState(true);

	useEffect(() => {
		if (openIcdCptDrawer2 && activeCode?.type === 'CPT') {
			setActiveTab('2');
		} else {
			setActiveTab('1');
		}
	}, [openIcdCptDrawer2]);

	// Example of handleCodeClick
	const handleCodeClick = (codeType, codeData) => {
		// Check if the code has leading or trailing spaces
		let trimmedCode = codeData.code;

		if (trimmedCode !== trimmedCode.trim()) {
			trimmedCode = trimmedCode.trim();
		}

		// // Check if it's a child code
		// const isChildCode = trimmedCode.includes('.');
		// const parentCode = isChildCode
		// 	? trimmedCode.split('.')[0]
		// 	: trimmedCode;
		setIcdCodes();
		closeIcdCptDrawer();
		setActiveCode({
			type: codeType,
			code: codeData.code,
			description: codeData.description,
			codeTypeText: codeData.codeTypeText,
			buttontext: codeData.buttontext,
		});

		if (codeType === 'CPT') {
			// // Set filters to fetch related codes
			setCptFilters({
				related: true,
				childCode: trimmedCode,
			});
			setCptTriggeredByEnter(true);
			setOpenIcdCptDrawer2(true); // Open the related codes drawer
			// setOpenIcdCptDrawer(false);
			setOpenCptDrawer(false);
			setOpenIcdDrawer(true);
			setActiveTab('2');
		} else {
			// Set filters to fetch related codes
			setIcdFilters({
				related: true,
				childCode: trimmedCode,
			});
			setTriggeredByEnter(true);
			setOpenIcdCptDrawer2(true); // Open the related codes drawer
			// setOpenIcdCptDrawer(false);
			setOpenIcdDrawer(false);
			setOpenCptDrawer(true);
			setActiveTab('1');
		}
	};

	const showIcdCptDrawer = () => {
		setOpenIcdCptDrawer(true);
		setIcdCodes();
		setActiveCode(null);
		setSearchResults();
		setIcdLoading(false);
		setTriggeredBySearch(false);
		setIcdSearchLoading(false);
		setLoadMore(false);
		icdform.resetFields();
		setCptCodes();
		setCptSearchResults();
		setCptLoading(false);
		setCptTriggeredBySearch(false);
		setCptSearchLoading(false);
		setCptLoadMore(false);
		cptform.resetFields();
	};

	const closeIcdCptDrawer = (flag) => {
		if (flag === 'true') {
		} else {
			setOpenIcdCptDrawer(false);
		}
		setOpenIcdDrawer(true);
		setOpenCptDrawer(true);
		setActiveCode(null);
		setIcdLoading(false);
		setTriggeredBySearch(false);
		setIcdSearchLoading(false);
		setLoadMore(false);
		icdform.resetFields();
		setCptLoading(false);
		setCptTriggeredBySearch(false);
		setCptSearchLoading(false);
		setCptLoadMore(false);
		cptform.resetFields();
	};

	const closeIcdCptDrawer2 = () => {
		setOpenIcdDrawer(true);
		setOpenCptDrawer(true);
		setOpenIcdCptDrawer2(false);
		setActiveCode(null);
		setIcdLoading(false);
		setTriggeredBySearch(false);
		setIcdSearchLoading(false);
		setLoadMore(false);
		icdform.resetFields();
		// showIcdCptDrawer();
		setCptLoading(false);
		setCptTriggeredBySearch(false);
		setCptSearchLoading(false);
		setCptLoadMore(false);
		cptform.resetFields();
	};

	const getBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});

	const handleCancel = () => setPreviewOpen(false);

	const updatePageContent = (title, id, content) => {
		if (id === null) {
			setPageContent({
				...pageContent,
				[title]: [...pageContent[[title]], content],
			});
		} else {
			const updatedPageContent = { ...pageContent };
			updatedPageContent[[title]][id] = content;
			setPageContent(updatedPageContent);
		}
		setModalOpen([false, '', ' ']);
		setModalTextArea('');
		form.resetFields();
		document.getElementById('notification')?.classList.remove('d-none');
	};

	const dateOfBirth = (inputDateString) => {
		const date = new Date(inputDateString);

		// Extract the year, month, and day components from the Date object
		const year = date.getFullYear();
		const month = date.getMonth() + 1; // Month is zero-based, so add 1
		const day = date.getDate();

		// Format the date as "MM-DD-YYYY" or any desired format
		return `${month.toString().padStart(2, '0')}-${day
			.toString()
			.padStart(2, '0')}-${year}`;
	};

	function compareDates(dateString, yearNumber) {
		// Parse the date string using Moment.js
		const dateOfBirth = moment(dateString);

		// Calculate the current year
		const currentYear = moment().year();

		// Extract the year from the parsed date of birth
		const birthYear = dateOfBirth.year();

		// Calculate the age by subtracting the birth year from the current year
		const age = currentYear - birthYear;
		// Extract the last two digits of the year number
		const yearDigits = parseInt(yearNumber.toString().slice(-2));
		// Compare the years
		return age === yearDigits;
	}
	function compareGender(patientGender, analysisGender) {
		// Get the first character of the analysisGender string and normalize to uppercase
		const firstCharAnalysis = analysisGender.charAt(0).toUpperCase();

		// Check if patientGender is "M" (Male) or "F" (Female)
		if (
			patientGender.toUpperCase() === 'MALE' ||
			patientGender.toUpperCase() === 'FEMALE'
		) {
			// Compare the first character of analysisGender with patientGender
			return firstCharAnalysis === patientGender.charAt(0).toUpperCase();
		} else {
			// Match patientGender with "O" (Other)
			return firstCharAnalysis === 'O';
		}
	}

	const handleAddOption = (index) => {
		setNewCheckBoxModal([true, index]);
		setNewOptionText('');
		newOptionForm.setFieldsValue({});
		newOptionForm.resetFields();
	};

	const handleNewCheckBoxModal = () => {
		// Create a new option object
		newOptionForm
			.validateFields()
			.then(() => {
				const newOption = {
					label: newOptionText,
					value: newOptionText,
				};

				if (
					newCheckBoxModal[1] !== null &&
					newCheckBoxModal[1] >= 0 &&
					newCheckBoxModal[1] < missingFields.length
				) {
					const updatedFields = [...missingFields];
					updatedFields[newCheckBoxModal[1]].options.push(newOption);
					setMissingFields(updatedFields);

					// Get the current form values
					const currentValues = missingFieldsForm.getFieldsValue();

					// Add the new option to the appropriate field and mark it as checked
					if (
						!currentValues[updatedFields[newCheckBoxModal[1]].name]
					) {
						currentValues[updatedFields[newCheckBoxModal[1]].name] =
							[];
					}
					currentValues[updatedFields[newCheckBoxModal[1]].name].push(
						newOptionText,
					);

					// Update the form with the new values
					missingFieldsForm.setFieldsValue(currentValues);
				}

				// Close the modal and reset the newOptionText state
				setNewCheckBoxModal([false, null]);
				setNewOptionText('');
				newOptionForm.setFieldsValue({});
				newOptionForm.resetFields();
			})
			.catch((info) => {
				console.log('Validate Failed:', info);
			});
	};

	// use effects
	useEffect(() => {
		if (id) getAnalysis({ id: id });
	}, [id]);

	useEffect(() => {
		if (showAnalysisData) {
			document.getElementById('getAns')?.classList.add('top-0');
			document.getElementById('getAns')?.classList.remove('top-100');
		}
	}, [showAnalysisData]);

	useEffect(() => {
		if (
			getAnalysisState.apiState === 'success'
			// !Object.keys(getAnalysisState.data.coverage_feedback_response)
			// 	.length > 0 &&
			// patientData.clinical_summary
		) {
			const { coverage_feedback_response } = getAnalysisState.data;

			// Check if coverage_feedback_response is empty or if "Medicare Evaluation" is missing or empty
			const isMedicareEvaluationEmpty =
				!coverage_feedback_response?.['Medicare Evaluation'] ||
				Object.keys(coverage_feedback_response['Medicare Evaluation'])
					.length === 0;

			// todo Case analtysis if clinical not thwre
			if (
				!coverage_feedback_response ||
				Object.keys(coverage_feedback_response).length === 0 ||
				isMedicareEvaluationEmpty
			) {
				if (patientData.allocated_to) {
					setLoading(true);
					document
						.getElementById('notification')
						?.classList.add('d-none');
					analyseCoverage({
						clinicalSummary: patientData.clinical_summary,
						case_id: patientData._id,
						state: patientData.state,
						provider: patientData.insurance_company?.name,
						supportingDocsSummary:
							patientData && patientData.summary_docs,
						revenue_cycle: patientData.revenue_cycle,
					});
				}
			}
			getAnalysisReset();
		}
	}, [patientData]);

	useEffect(() => {
		if (getAnalysisState.apiState === 'error') {
			setMainDataLoading(false);
		}
		if (getAnalysisState.apiState === 'success') {
			setMainDataLoading(false);
			if (
				getAnalysisState.data.case_details &&
				getAnalysisState.data.case_details.allocated_to === null
			) {
				notification.error({
					message: 'Case Not Allocated',
					description:
						"Oops! It seems like this case hasn't been allocated to anyone yet. Please allocate it first before proceeding with the analysis.",
				});
			}
			setPatientData(getAnalysisState.data.case_details);
			setPageContent({
				...pageContent,
				originalQuery:
					getAnalysisState.data.coverage_feedback_response[
						'original_query'
					] ?? '-',
				pastHistory:
					getAnalysisState.data.coverage_feedback_response[
						'Past History'
					] ?? [],
				presentComplaint:
					getAnalysisState.data.coverage_feedback_response[
						'Present Complaint'
					] ?? [],
				recommendedProcedure:
					getAnalysisState.data.coverage_feedback_response[
						'Suggested Treatment'
					] ?? [],
				medicalCoverage: [
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['Coverage']
						: 'No',
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['Rationale']
						: '-',
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['reference']
						: null,
				],
				missing_points_for_coverage:
					getAnalysisState.data.coverage_feedback_response
						.missing_points_for_coverage ?? [],
				status: getAnalysisState.data.coverage_feedback_response.status,
				ncd_reference:
					getAnalysisState.data.coverage_feedback_response[
						'NCD References'
					] ?? '',
				retired_message:
					getAnalysisState.data.coverage_feedback_response
						.retired_message ?? '',
				is_retired:
					getAnalysisState.data.coverage_feedback_response
						.is_retired ?? 0,
			});
			if (
				getAnalysisState.data.coverage_feedback_response &&
				getAnalysisState.data.coverage_feedback_response.age
			)
				if (
					getAnalysisState.data.coverage_feedback_response &&
					getAnalysisState.data.coverage_feedback_response.gender
				)
					setMatchGender(
						compareGender(
							getAnalysisState.data.case_details.gender,
							getAnalysisState.data.coverage_feedback_response
								.gender,
						),
					);
			setLastAnalysisData(
				getAnalysisState.data?.coverage_feedback_response,
			);
			setFeedbackId(getAnalysisState.data.coverage_feedback_response._id);
			document.getElementById('getAns')?.classList.add('top-0');
			document.getElementById('getAns')?.classList.remove('top-100');

			// Check if the last timeline entry indicates that the case is closed
			const lastTimelineEntry =
				getAnalysisState.data.timelineData?.slice(-1)[0];
			if (
				lastTimelineEntry &&
				(lastTimelineEntry.appeal_status === 'Approved' ||
					lastTimelineEntry.appeal_status === 'Rejected')
			) {
				setCaseClosed(true);
			} else {
				setCaseClosed(false);
			}

			const supportingDocs =
				getAnalysisState.data.case_details.supporting_docs.length > 0 &&
				getAnalysisState.data.case_details.supporting_docs.map(
					(doc) => {
						return doc;
					},
				);
			setDocumentsToDisplay(supportingDocs);

			const clinicalDocs =
				getAnalysisState.data.case_details.clinical_docs.map((doc) => {
					return doc;
				});
			setClinicalDocumentsToDisplay(clinicalDocs);
		}
	}, [getAnalysisState.apiState]);

	useEffect(() => {
		if (analyseCoverageState.apiState === 'success') {
			setFeedbackId(analyseCoverageState.data.feedback_id);
			setLastAnalysisData(analyseCoverageState.data);
			setPageContent({
				...pageContent,
				originalQuery:
					analyseCoverageState.data['original_query'] ?? '',
				pastHistory: analyseCoverageState.data['Past History'] ?? [],
				presentComplaint:
					analyseCoverageState.data['Present Complaint'] ?? [],
				recommendedProcedure:
					analyseCoverageState.data['Suggested Treatment'] ?? [],
				medicalCoverage: [
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'Coverage'
						  ]
						: 'No',
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'Rationale'
						  ]
						: '',
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'reference'
						  ]
						: null,
				],
				missing_points_for_coverage:
					analyseCoverageState.data.missing_points_for_coverage ?? [],
				ncd_reference:
					analyseCoverageState.data['NCD References'] ?? '',
				retired_message:
					analyseCoverageState.data.retired_message ?? '',
				is_retired: analyseCoverageState.data.is_retired ?? 0,
			});
			setAnalysisCompleted('success');
			summaryForm.resetFields();
			analyseCoverageReset();
			// setLoading(false);
			if (
				analyseCoverageState.data &&
				analyseCoverageState.data.date_of_birth
			)
				if (
					analyseCoverageState.data &&
					analyseCoverageState.data.gender
				)
					setMatchGender(
						compareGender(
							patientData.gender,
							analyseCoverageState.data.gender,
						),
					);
			if (
				analyseCoverageState.data.hasOwnProperty('is_fields_missing') &&
				analyseCoverageState.data.is_fields_missing &&
				analyseCoverageState.data.hasOwnProperty('missing_fields')
			) {
				if (analyseCoverageState.data.missing_fields.length > 0) {
					setMissingFields(
						analyseCoverageState.data.missing_fields ?? [],
					);
					setMissingFieldInstructions(
						analyseCoverageState.data.missing_field_instructions ??
							[],
					);
					setMissingFieldTitle(
						analyseCoverageState.data.missing_field_title ?? '',
					);
					setMissingFieldsModal(true);
					setIsMissingFieldsThere(true);
				}
			} else {
				setShowAnalysisData(true);
				// if (id) getAnalysis({ id: id });
			}
		}

		if (analyseCoverageState.apiState === 'error') {
			// setLoading(false);
			setIsMissingFieldsThere(false);
			notification.error({
				message:
					'Hey, we are facing high traffic. Please check back in few minutes.',
			});
			analyseCoverageReset();
		}
	}, [analyseCoverageState]);

	useEffect(() => {
		if (reviseCoverageState.apiState === 'success') {
			setFeedbackId(reviseCoverageState.data.feedback_id);
			setLastAnalysisData(reviseCoverageState.data);
			setPageContent({
				...pageContent,
				originalQuery: reviseCoverageState.data['original_query'] ?? '',
				pastHistory: reviseCoverageState.data['Past History'] ?? [],
				presentComplaint:
					reviseCoverageState.data['Present Complaint'] ?? [],
				recommendedProcedure:
					reviseCoverageState.data['Suggested Treatment'] ?? [],
				medicalCoverage: [
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'Coverage'
						  ]
						: 'No',
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'Rationale'
						  ]
						: '',
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'reference'
						  ]
						: null,
				],
				missing_points_for_coverage:
					reviseCoverageState.data.missing_points_for_coverage ?? [],
				status: reviseCoverageState.data.status,
				ncd_reference: reviseCoverageState.data['NCD References'] ?? '',
				retired_message: reviseCoverageState.data.retired_message ?? '',
				is_retired: reviseCoverageState.data.is_retired ?? 0,
			});
			setAnalysisCompleted('success');
			if (reviseCoverageState.data && reviseCoverageState.data.age)
				if (reviseCoverageState.data && reviseCoverageState.data.gender)
					setMatchGender(
						compareGender(
							patientData.gender,
							reviseCoverageState.data.gender,
						),
					);
			if (
				reviseCoverageState.data.hasOwnProperty('is_fields_missing') &&
				reviseCoverageState.data.is_fields_missing &&
				reviseCoverageState.data.hasOwnProperty('missing_fields')
			) {
				if (reviseCoverageState.data.missing_fields.length > 0) {
					setMissingFields(
						reviseCoverageState.data.missing_fields ?? [],
					);
					setMissingFieldInstructions(
						reviseCoverageState.data.missing_field_instructions ??
							[],
					);
					setMissingFieldTitle(
						reviseCoverageState.data.missing_field_title ?? '',
					);
					setMissingFieldsModal(true);
					setIsMissingFieldsThere(true);
				}
			} else {
				setShowAnalysisData(true);
				setIsMissingFieldsThere(false);
				// if (id) getAnalysis({ id: id });
			}
			reviseCoverageReset();
			// setLoading(false);
		} else if (reviseCoverageState.apiState === 'error') {
			setLoading(false);
			setAnalysisCompleted('error');
			notification.error({
				message:
					'Hey, we are facing high traffic. Please check back in few minutes.',
			});
			document.getElementById('notification')?.classList.remove('d-none');
			reviseCoverageReset();
		}
	}, [reviseCoverageState]);

	useEffect(() => {
		if (sendFeedbackState.apiState === 'success') {
			setCoverageLoading(false);
			setLooksGoodLoading(false);
			setModalOpen([false, '', '']);
			if (sendFeedbackState.data === 'negative')
				setThanksModal([true, 'Thanks for making us Better!']);
			else
				setThanksModal([true, 'Case has been analysed and confirmed!']);
			sendFeedbackReset();
			if (id) getAnalysis({ id: id });
		}
		if (sendFeedbackState.apiState === 'error') {
			setCoverageLoading(false);
			setLooksGoodLoading(false);
		}
	}, [sendFeedbackState]);

	const handleUploadCancel = () => {
		setIsClinicalUploadModalOpen(false);
		setClinicalDocumentFileList([]);
		setUpdatedClinicalDocumentFileList([]);
		setClinicalDocsLoading(false);
		setSubmitClinicalDocs(false);
		clinicalDocsForm.setFieldsValue({ clinical_docs: '' });
	};

	const handleClinicalDocsChange = ({ fileList: newFileList }) => {
		const updatedFileList = newFileList.map((file) => {
			if (file.status === 'error') {
				return { ...file, status: 'done' };
			}
			return file;
		});
		setClinicalDocumentFileList(updatedFileList);
		clinicalDocsForm.validateFields(['clinical_docs']);
	};

	useEffect(() => {
		if (submitClinicalDocs) {
			editCase({
				id: id,
				clinical_docs: updatedClinicalDocumentFileList,
				upload_documents: true,
				remove: true,
			});
		}
	}, [submitClinicalDocs]);

	useEffect(() => {
		if (editCaseState.apiState === 'success') {
			setClinicalSummaryTextLoading(false);
			handleUploadCancel();
			setClinicalDocsLoading(false);
			setShowClinicalTextArea(false);
			notification.success({
				message: editCaseState.message,
			});
			setModalOpen([false, '']);
			getAnalysis({ id: id });
			editCaseReset();
		}
		if (editCaseState.apiState === 'error') {
			setClinicalSummaryTextLoading(false);
			handleUploadCancel();
			setClinicalDocsLoading(false);
			setShowClinicalTextArea(false);
			notification.error({
				message: editCaseState.message
					? editCaseState.message
					: 'Unable to update case status, Please try again',
			});
		}
		editCaseReset();
	}, [editCaseState]);

	useEffect(() => {
		if (missingFieldsModal && missingFieldsCardRef.current) {
			missingFieldsCardRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	}, [missingFieldsModal]);

	useEffect(() => {
		let timer;
		if (thanksModal) {
			timer = setTimeout(() => {
				setThanksModal([false, '']);
			}, 5000);
		}

		// Clear the timer if the component unmounts or showThanksModal changes
		return () => clearTimeout(timer);
	}, [thanksModal]);

	const capitalizeFirstLetter = (string) => {
		if (!string) return string; // Return the string if it's null or undefined
		return string.charAt(0).toUpperCase() + string.slice(1);
	};
	return (
		<>
			{/* Notification Bar to raeanalyse */}
			<XContainer fluid>
				<div className="marginTopMobile "></div>
				<XAffix
					id="notification"
					className="d-none zIndex"
					offsetTop={10}
				>
					<div className="marginBottomMobile"></div>
					<div
						className="mb-3"
						style={{
							backgroundColor: 'white',
							borderRadius: '20px',
							zIndex: '1110',
						}}
					>
						<XNotificationBar>
							Clinical Summary has been changed !! Click to{' '}
							<XButtonReload
								type="button"
								style={{ padding: '18px' }}
								className="refreshBtn"
								onClick={() => {
									closeIcdCptDrawer2();
									setLoading(true);
									document
										.getElementById('notification')
										?.classList.add('d-none');

									reviseCoverageReset();
									// Update lastAnalysisData with the latest pageContent values
									const updatedLastAnalysisData = {
										...lastAnalysisData, // Keep all the existing keys and values intact
										'Past History': pageContent.pastHistory, // Update pastHistory
										'Present Complaint':
											pageContent.presentComplaint, // Update presentComplaint
										'Suggested Treatment':
											pageContent.recommendedProcedure, // Update recommendedProcedure
										'Medicare Evaluation': {
											...lastAnalysisData[
												'Medicare Evaluation'
											],
											Coverage:
												pageContent.medicalCoverage[0], // Update medicalCoverage fields
											Rationale:
												pageContent.medicalCoverage[1],
											reference:
												pageContent.medicalCoverage[2],
										},
										original_query:
											pageContent.originalQuery, // Update original_query
										past_history: pageContent.pastHistory, // Update past_history in lastAnalysisData
										present_complaint:
											pageContent.presentComplaint, // Update present_complaint in lastAnalysisData
										status: pageContent.status, // Update status in lastAnalysisData
										missing_points_for_coverage:
											pageContent.missing_points_for_coverage, // Update missing_points_for_coverage
										// Add other updates if necessary, or keep them unchanged
									};
									reviseCoverage({
										case_id: patientData._id,
										feedbackId: feedbackId,
										clinicalHistory:
											pageContent.pastHistory,
										presentComplaint:
											pageContent.presentComplaint,
										recommendedProcedure:
											pageContent.recommendedProcedure,
										medicalCoverage:
											pageContent.medicalCoverage,
										state: patientData.state,
										provider:
											patientData.insurance_company?.name,
										last_analysis_data:
											updatedLastAnalysisData,
										supportingDocsSummary:
											patientData &&
											patientData.summary_docs,
										revenue_cycle:
											patientData.revenue_cycle,
									});
								}}
							>
								Reanalyse it !!
							</XButtonReload>
							<XButtonCloseBar
								type="button"
								className="closeBar mt-3"
							>
								<CloseOutlined
									onClick={() => {
										document
											.getElementById('notification')
											?.classList.add('d-none');
									}}
									style={{ fontSize: '20px' }}
								/>
							</XButtonCloseBar>
						</XNotificationBar>
					</div>
					<div className="marginNone"></div>
				</XAffix>
			</XContainer>
			<>
				<Col lg={24} xl={24} xs={0} md={0}>
					<Header
						className="mt-4"
						headerTag="Case Analysis"
						breadcrumb="true"
						link="/case-analysis"
						caseId={patientData.case_id}
					/>
				</Col>
				<Col lg={0} xl={0} xs={24} md={24}>
					<HeaderFile activeNav="analyseCoverage" />
				</Col>
			</>
			{/* <div id="notification" className="d-none marginNone" ></div> */}
			<XContainer fluid>
				{checkModulePermissions('case-analysis').authorized ? (
					<>
						<Row gutter={(0, 30)}>
							{mainDataLoading ? (
								<>
									<Skeleton
										active
										paragraph={{
											rows: 8,
										}}
									/>
								</>
							) : (
								<>
									<Col xs={24} className="mb-3">
										<XThemeCardCaseOperations
											title={
												<div className="customWidthHeaderWrap">
													<div className="customWidthHeadIcon">
														<XThemeAvatarName
															size={50}
														>
															{patientData.patient_first_name &&
																patientData
																	?.patient_first_name[0]}
															{patientData.patient_last_name &&
																patientData
																	?.patient_last_name[0]}
															{/* {patientData.patient_first_name[0]}
																			{patientData.patient_last_name[0]} */}
														</XThemeAvatarName>
													</div>
													<div className="customWidthHeader">
														<Row
															gutter={[15, 15]}
															className="align-items-center"
														>
															<Col span={20}>
																<XTheme2MainTitle2
																	style={{
																		color:
																			currentRevision?.field ===
																				'patient_first_name' ||
																			currentRevision?.field ===
																				'patient_last_name'
																				? '#007299'
																				: '',

																		// backgroundColor:
																		// 	currentRevision?.field ===
																		// 		'patient_first_name' ||
																		// 	currentRevision?.field ===
																		// 		'patient_last_name'
																		// 		? 'rgba(223,235,240,0.5)'
																		// 		: '',
																	}}
																>
																	{currentRevision?.field ===
																	'patient_first_name'
																		? `${
																				currentRevision?.newValue
																		  }${' '}${
																				patientData.patient_last_name &&
																				patientData?.patient_last_name
																		  }`
																		: currentRevision?.field ===
																		  'patient_last_name'
																		? `${
																				patientData.patient_first_name &&
																				patientData?.patient_first_name
																		  }${
																				currentRevision?.newValue
																		  }`
																		: patientData.patient_name}
																</XTheme2MainTitle2>

																<XTheme2TableCircleTag
																	className={
																		patientData.status
																	}
																>
																	{toTitleCase(
																		patientData.status,
																	)}{' '}
																</XTheme2TableCircleTag>
																{patientData.status ===
																'letter_sent' ? (
																	<XTheme2TableCircleTag
																		className={
																			patientData.status
																		}
																	>
																		{toTitleCase(
																			patientData.status,
																		)}
																	</XTheme2TableCircleTag>
																) : (
																	''
																)}
																<XThemeAvatarText>
																	DOB:{' '}
																	<span
																		className={
																			currentRevision?.field ===
																			'date_of_birth'
																				? 'highlight'
																				: ''
																		}
																	>
																		{currentRevision?.field ===
																		'date_of_birth'
																			? dateOfBirth(
																					currentRevision?.newValue,
																			  )
																			: patientData.date_of_birth
																			? dateOfBirth(
																					patientData.date_of_birth,
																			  )
																			: ''}
																	</span>
																	<span
																		className={
																			currentRevision?.field ===
																			'gender'
																				? 'highlight'
																				: 'me-0'
																		}
																	>
																		&#128900;{' '}
																		{currentRevision?.field ===
																		'gender'
																			? toTitleCase(
																					currentRevision?.newValue,
																			  )
																			: patientData.gender
																			? toTitleCase(
																					patientData.gender,
																			  )
																			: ''}
																		&nbsp;
																		{matchGender ? (
																			<>
																				{' '}
																			</>
																		) : (
																			<Tooltip
																				title="The gender of the patient does not correspond with the gender entered in the Clinical Summary."
																				trigger={
																					'hover'
																				}
																			>
																				<WarningOutlined
																					style={{
																						color: 'red',
																					}}
																				/>
																			</Tooltip>
																		)}
																	</span>
																	&#128900;
																</XThemeAvatarText>
															</Col>
														</Row>
													</div>
												</div>
											}
										>
											<XThemeAddressWrap className="noPadding">
												<Row
													gutter={[15, 15]}
													className="align-items-center mb-3"
												>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-1.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Revenue Cycle
																Stage
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'revenue_cycle_stage'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'revenue_cycle_stage'
																		? currentRevision?.newValue ===
																				'organization_determination' &&
																		  'Organization Determination'
																		: patientData.revenue_cycle_stage ===
																				'organization_determination' &&
																		  'Organization Determination'}
																	{currentRevision?.field ===
																	'revenue_cycle_stage'
																		? currentRevision?.newValue ===
																				'first_appeal' &&
																		  'First Appeal'
																		: patientData.revenue_cycle_stage ===
																				'first_appeal' &&
																		  'First Appeal'}
																	{currentRevision?.field ===
																	'revenue_cycle_stage'
																		? currentRevision?.newValue ===
																				'second_appeal' &&
																		  'Second Appeal'
																		: patientData.revenue_cycle_stage ===
																				'second_appeal' &&
																		  'Second Appeal'}
																	{currentRevision?.field ===
																	'revenue_cycle_stage'
																		? currentRevision?.newValue ===
																				'third_appeal' &&
																		  'Third Appeal'
																		: patientData.revenue_cycle_stage ===
																				'third_appeal' &&
																		  'Third Appeal'}
																	{currentRevision?.field ===
																	'revenue_cycle_stage'
																		? currentRevision?.newValue ===
																				'fourth_appeal' &&
																		  'Fourth Appeal'
																		: patientData.revenue_cycle_stage ===
																				'fourth_appeal' &&
																		  'Fourth Appeal'}
																	{currentRevision?.field ===
																	'revenue_cycle_stage'
																		? currentRevision?.newValue ===
																				'judicial_review' &&
																		  'Judicial Review'
																		: patientData.revenue_cycle_stage ===
																				'judicial_review' &&
																		  'Judicial Review'}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-2.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																State
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'state'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'state'
																		? currentRevision?.newValue
																		: patientData.state}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-4.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Organization
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'organization'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'organization'
																		? currentRevision
																				?.newValue
																				?.name
																		: patientData
																				.organization
																				?.name ??
																		  '-'}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-5.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Hospital
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'hospital'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'hospital'
																		? currentRevision
																				?.newValue
																				?.name
																		: patientData
																				.hospital
																				?.name ??
																		  '-'}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-6.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Insurance Claim
																Number <br />
																<span
																	className={
																		currentRevision?.field ===
																		'insurance_claim_number'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'insurance_claim_number'
																		? currentRevision?.newValue
																		: patientData?.insurance_claim_number ??
																		  '-'}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-7.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Insurance
																Company
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'insurance_company'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'insurance_company'
																		? currentRevision
																				?.newValue
																				?.name
																		: patientData
																				.insurance_company
																				?.name ??
																		  '-'}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-8.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Region
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'region'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'region'
																		? currentRevision
																				?.newValue
																				?.name
																		: patientData
																				.region
																				?.name ??
																		  '-'}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-9.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Claim Amount
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'claim_amount'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'claim_amount'
																		? `$${currentRevision?.newValue}`
																		: patientData.claim_amount
																		? `$${patientData.claim_amount}`
																		: '-'}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-9.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Case Amount
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'case_amount'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'case_amount'
																		? `$${currentRevision?.newValue}`
																		: patientData.case_amount
																		? `$${patientData.case_amount}`
																		: '-'}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<UserOutlined />
															</div>
															<div className="heading mb-0">
																Allocated to
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'allocated_to'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'allocated_to'
																		? currentRevision
																				?.newValue
																				?.name
																		: patientData
																				.allocated_to
																				?.name ??
																		  '-'}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-1.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Revenue Cycle
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'revenue_cycle'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'revenue_cycle'
																		? currentRevision?.newValue ===
																				'pre_service' &&
																		  'Pre Service'
																		: patientData.revenue_cycle ===
																				'pre_service' &&
																		  'Pre Service'}
																	{currentRevision?.field ===
																	'revenue_cycle'
																		? currentRevision?.newValue ===
																				'post_claim' &&
																		  'Post Claim'
																		: patientData.revenue_cycle ===
																				'post_claim' &&
																		  'Post Claim'}
																	{currentRevision?.field ===
																	'revenue_cycle'
																		? currentRevision?.newValue ===
																				'part_b_drugs' &&
																		  'Part B Drugs'
																		: patientData.revenue_cycle ===
																				'part_b_drugs' &&
																		  'Part B Drugs'}
																	{currentRevision?.field ===
																	'revenue_cycle'
																		? currentRevision?.newValue ===
																				'pre_service_part_c' &&
																		  'Pre Service Part C'
																		: patientData.revenue_cycle ===
																				'pre_service_part_c' &&
																		  'Pre Service Part C'}
																	{currentRevision?.field ===
																	'revenue_cycle'
																		? currentRevision?.newValue ===
																				'post_claim_part_c' &&
																		  'Post Claim Part C'
																		: patientData.revenue_cycle ===
																				'post_claim_part_c' &&
																		  'Post Claim Part C'}
																</span>
															</div>
														</Space>
													</Col>

													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-10.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Providers
																Encounter Number{' '}
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'providers_encounter_number'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'providers_encounter_number'
																		? currentRevision?.newValue
																		: patientData?.providers_encounter_number ??
																		  '-'}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-11.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Discharge Date
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'date_of_discharge'
																			? 'highlight'
																			: ''
																	}
																>
																	{/* {patientData.date_of_discharge ?? '-'} */}
																	{currentRevision?.field ===
																	'date_of_discharge'
																		? dateOfBirth(
																				currentRevision?.newValue,
																		  )
																		: patientData.date_of_discharge
																		? dateOfBirth(
																				patientData.date_of_discharge,
																		  )
																		: ''}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-11.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Hearing Date
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'hearing_date'
																			? 'highlight'
																			: ''
																	}
																>
																	{/* {patientData.hearing_date ?? '-'} */}
																	{currentRevision?.field ===
																	'hearing_date'
																		? dateOfBirth(
																				currentRevision?.newValue,
																		  )
																		: patientData.hearing_date
																		? dateOfBirth(
																				patientData.hearing_date,
																		  )
																		: ''}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-11.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Admission Date
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'date_of_admission'
																			? 'highlight'
																			: ''
																	}
																>
																	{/* {patientData.date_of_admission ?? '-'} */}
																	{currentRevision?.field ===
																	'date_of_admission'
																		? dateOfBirth(
																				currentRevision?.newValue,
																		  )
																		: patientData.date_of_admission
																		? dateOfBirth(
																				patientData.date_of_admission,
																		  )
																		: ''}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-11.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																EOB Date
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'date_of_eob'
																			? 'highlight'
																			: ''
																	}
																>
																	{/* {patientData.date_of_eob ?? '-'} */}
																	{currentRevision?.field ===
																	'date_of_eob'
																		? dateOfBirth(
																				currentRevision?.newValue,
																		  )
																		: patientData.date_of_eob
																		? dateOfBirth(
																				patientData.date_of_eob,
																		  )
																		: ''}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-1.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Process Type
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'process_type'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'process_type'
																		? currentRevision?.newValue ===
																				'ma_standard' &&
																		  'MA Standard Appeal Turn-Around-Time (TAT)'
																		: patientData.process_type ===
																				'ma_standard' &&
																		  'MA Standard Appeal Turn-Around-Time (TAT)'}
																	{currentRevision?.field ===
																	'process_type'
																		? currentRevision?.newValue ===
																				'ma_expedited' &&
																		  'MA Expedited Appeal Turn-Around-Time (TAT)'
																		: patientData.process_type ===
																				'ma_expedited' &&
																		  'MA Expedited Appeal Turn-Around-Time (TAT)'}
																	{/* {currentRevision?.field ===
																		'process_type'
																			? currentRevision?.newValue
																			: patientData.process_type ?? '-'} */}
																</span>
															</div>
														</Space>
													</Col>
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-12.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Visit Type
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'visit_type'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'visit_type'
																		? currentRevision?.newValue
																		: patientData.visit_type ??
																		  '-'}
																</span>
															</div>
														</Space>
													</Col>
													{/* status */}
													<Col
														xs={24}
														sm={12}
														md={12}
														lg={8}
													>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-13.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Status
																<br />
																<span
																	className={
																		currentRevision?.field ===
																		'status'
																			? 'highlight'
																			: ''
																	}
																>
																	{currentRevision?.field ===
																	'status'
																		? capitalizeFirstLetter(
																				currentRevision?.newValue,
																		  )
																		: capitalizeFirstLetter(
																				patientData.status ??
																					'-',
																		  )}
																</span>
															</div>
														</Space>
													</Col>
													{/* New Date of Service Column */}
													<Col xs={24}>
														<Space className="align-items-center">
															<div className="iconWrapper">
																<img
																	src="/images/prof-11.svg"
																	alt=""
																/>
															</div>
															<div className="heading mb-0">
																Date of Service{' '}
																<br />
																<div
																	style={{
																		display:
																			'flex',
																		flexWrap:
																			'wrap',
																	}}
																>
																	{/* Display single dates if available */}
																	{currentRevision?.field !==
																		'date_of_service' &&
																		patientData
																			.date_of_service
																			?.single_date
																			?.length >
																			0 && (
																			<>
																				{patientData.date_of_service.single_date.map(
																					(
																						date,
																						index,
																					) => (
																						<span
																							key={
																								index
																							}
																						>
																							{dayjs(
																								date,
																							).format(
																								'MM-DD-YYYY',
																							)}
																							{
																								index <
																									patientData
																										.date_of_service
																										.single_date
																										.length -
																										1 && (
																									<span>
																										,&nbsp;
																									</span>
																								)
																								// ', '
																							}
																						</span>
																					),
																				)}
																			</>
																		)}
																	{currentRevision?.field ===
																		'date_of_service' &&
																		currentRevision
																			?.newValue
																			?.single_date
																			?.length >
																			0 && (
																			<>
																				{currentRevision?.newValue?.single_date.map(
																					(
																						date,
																						index,
																					) => (
																						<span
																							className="highlight"
																							key={
																								index
																							}
																						>
																							{dayjs(
																								date,
																							).format(
																								'MM-DD-YYYY',
																							)}
																							{
																								index <
																									currentRevision
																										.newValue
																										.single_date
																										.length -
																										1 && (
																									<span>
																										,&nbsp;
																									</span>
																								)
																								// ', '
																							}
																						</span>
																					),
																				)}
																			</>
																		)}
																	{/* Display a separator if both single dates and date ranges exist */}
																	{
																		currentRevision?.field !==
																			'date_of_service' &&
																			patientData
																				.date_of_service
																				?.single_date
																				?.length >
																				0 &&
																			patientData
																				.date_of_service
																				?.date_range
																				?.length >
																				0 && (
																				<span>
																					,&nbsp;
																				</span>
																			)
																		// ', '
																	}
																	{
																		currentRevision?.field ===
																			'date_of_service' &&
																			currentRevision
																				?.newValue
																				?.single_date
																				?.length >
																				0 &&
																			currentRevision
																				?.newValue
																				?.date_range
																				?.length >
																				0 && (
																				<span>
																					,&nbsp;
																				</span>
																			)
																		// ', '
																	}
																	{/* Display date ranges if available */}
																	{currentRevision?.field !==
																		'date_of_service' &&
																		patientData
																			.date_of_service
																			?.date_range
																			?.length >
																			0 && (
																			<>
																				{patientData.date_of_service.date_range.map(
																					(
																						range,
																						index,
																					) => (
																						<span
																							key={
																								index
																							}
																						>
																							{range[0]
																								? dayjs(
																										range[0],
																								  ).format(
																										'MM-DD-YYYY',
																								  )
																								: ''}
																							{
																								' to '
																							}
																							{range[1]
																								? dayjs(
																										range[1],
																								  ).format(
																										'MM-DD-YYYY',
																								  )
																								: ''}
																							{index <
																								patientData
																									.date_of_service
																									.date_range
																									.length -
																									1 && (
																								<span>
																									,&nbsp;
																								</span>
																							)}
																						</span>
																					),
																				)}
																			</>
																		)}
																	{currentRevision?.field ===
																		'date_of_service' &&
																		currentRevision
																			?.newValue
																			?.date_range
																			?.length >
																			0 && (
																			<>
																				{currentRevision?.newValue?.date_range.map(
																					(
																						range,
																						index,
																					) => (
																						<span
																							className="highlight"
																							key={
																								index
																							}
																						>
																							{range[0]
																								? dayjs(
																										range[0],
																								  ).format(
																										'MM-DD-YYYY',
																								  )
																								: ''}
																							{
																								' to '
																							}
																							{range[1]
																								? dayjs(
																										range[1],
																								  ).format(
																										'MM-DD-YYYY',
																								  )
																								: ''}
																							{
																								index <
																									currentRevision
																										.newValue
																										.date_range
																										.length -
																										1 && (
																									<span>
																										,&nbsp;
																									</span>
																								)
																								// ', '
																							}
																						</span>
																					),
																				)}
																			</>
																		)}
																	{/* Placeholder if no dates are selected */}
																	{!(
																		patientData
																			.date_of_service
																			?.single_date
																			?.length >
																			0 ||
																		patientData
																			.date_of_service
																			?.date_range
																			?.length >
																			0
																	) && '-'}
																</div>
															</div>
														</Space>
													</Col>
												</Row>
											</XThemeAddressWrap>
										</XThemeCardCaseOperations>
									</Col>

									<Col xs={24}>
										{loading && (
											<AnalysisLoader
												analysisId={id}
												analysisCompleted={
													analysisCompleted
												}
												setAnalysisCompleted={
													setAnalysisCompleted
												}
												setLoading={setLoading}
												loading={loading}
												setIsMissingFieldsThere={
													setIsMissingFieldsThere
												}
												isMissingFieldsThere={
													isMissingFieldsThere
												}
											/>
										)}

										<CaseOperations
											aipa={false}
											previewMode={caseClosed}
											matchGender={matchGender}
											dateOfBirth={dateOfBirth}
											loading={loading}
											patientData={patientData}
											mainDataLoading={mainDataLoading}
											handleClinicalDocsChange={
												handleClinicalDocsChange
											}
											clinicalDocumentFileList={
												clinicalDocumentFileList
											}
											clinicalDocsForm={clinicalDocsForm}
											handleUploadCancel={
												handleUploadCancel
											}
											clinicalDocsLoading={
												clinicalDocsLoading
											}
											setIsClinicalUploadModalOpen={
												setIsClinicalUploadModalOpen
											}
											isClinicalUploadModalOpen={
												isClinicalUploadModalOpen
											}
											setPreviewImage={setPreviewImage}
											previewImage={previewImage}
											setPreviewTitle={setPreviewTitle}
											previewTitle={previewTitle}
											setPdfPreviewOpen={
												setPdfPreviewOpen
											}
											pdfPreviewOpen={pdfPreviewOpen}
											documentsToDisplay={
												documentsToDisplay
											}
											clinicalSummaryTextLoading={
												clinicalSummaryTextLoading
											}
											setClinicalSummaryTextLoading={
												setClinicalSummaryTextLoading
											}
											setShowClinicalTextArea={
												setShowClinicalTextArea
											}
											showClinicalTextArea={
												showClinicalTextArea
											}
											setFormData={setFormData}
											formData={formData}
											id={id}
											editCase={editCase}
											setPageContent={setPageContent}
											pageContent={pageContent}
											clinicalDocumentsToDisplay={
												clinicalDocumentsToDisplay
											}
											feedbackId={feedbackId}
											reviseCoverage={reviseCoverage}
											lastAnalysisData={lastAnalysisData}
											// closeIcdCptDrawer2={closeIcdCptDrawer2}
											// closeIcdCptDrawer={closeIcdCptDrawer}
											setLoading={setLoading}
											getBase64={getBase64}
											setClinicalDocsLoading={
												setClinicalDocsLoading
											}
											setSubmitClinicalDocs={
												setSubmitClinicalDocs
											}
											setUpdatedClinicalDocumentFileList={
												setUpdatedClinicalDocumentFileList
											}
											form={form}
											setModalTextArea={setModalTextArea}
											setModalOpen={setModalOpen}
											handleCodeClick={handleCodeClick}
											modalOpen={modalOpen}
											sendFeedback={sendFeedback}
											sendFeedbackState={
												sendFeedbackState
											}
											modalTextArea={modalTextArea}
											updatePageContent={
												updatePageContent
											}
											missingFieldsForm={
												missingFieldsForm
											}
											missingFieldsCardRef={
												missingFieldsCardRef
											}
											handleAddOption={handleAddOption}
											missingFields={missingFields}
											missingFieldInstructions={
												missingFieldInstructions
											}
											setMissingFieldsModal={
												setMissingFieldsModal
											}
											setMissingFieldInstructions={
												setMissingFieldInstructions
											}
											setMissingFields={setMissingFields}
											missingFieldTitle={
												missingFieldTitle
											}
											missingFieldsModal={
												missingFieldsModal
											}
											selectedProvider={''}
											selectedModel={''}
											revenueCycle={''}
											collapsed={collapsed}
										/>

										{checkModulePermissions(
											'ma-plan-appeals-processing',
										).sub_modules.includes(
											'update-coverage',
										) ||
										checkModulePermissions(
											'case-filing',
										).sub_modules.includes(
											'update-coverage',
										) ? (
											!caseClosed &&
											!missingFieldsModal && (
												<>
													<div className="showMobile">
														<Row
															gutter={(15, 15)}
															className="mt-4"
														>
															<Col xs={12}>
																<XButtonConfirm
																	className="w-100"
																	type="primary"
																	size="large"
																	shape="round"
																	style={{
																		background:
																			'#fff',
																	}}
																	icon={
																		<img
																			className="rotateButton"
																			src="/images/like-icon.svg"
																			alt=""
																		/>
																	}
																	onClick={() => {
																		form.setFieldsValue(
																			{
																				modal_text_area:
																					pageContent.medicalCoverage
																						? pageContent
																								.medicalCoverage[1]
																						: '',
																				medicare_flag:
																					pageContent.medicalCoverage
																						? pageContent
																								.medicalCoverage[0]
																						: '',
																			},
																		);
																		setModalTextArea(
																			pageContent
																				.medicalCoverage[1],
																		);
																		setModalOpen(
																			[
																				true,
																				`Edit Medicare Coverage`,
																				pageContent
																					.medicalCoverage[1],
																				1,
																				'feedbackSummary',
																			],
																		);
																	}}
																>
																	Refine
																</XButtonConfirm>
															</Col>
															<Col xs={12}>
																<XButtonConfirm
																	className="w-100"
																	type="primary"
																	size="large"
																	shape="round"
																	style={{
																		background:
																			'#fff',
																	}}
																	icon={
																		<img
																			src="/images/like-icon.svg"
																			alt=""
																		/>
																	}
																	loading={
																		LooksGoodLoading
																	}
																	onClick={() => {
																		setLooksGoodLoading(
																			true,
																		);
																		sendFeedback(
																			{
																				feedback_id:
																					feedbackId,
																				feedback:
																					'positive',
																				status: 'approved',
																				response:
																					pageContent.medicalCoverage,
																			},
																		);
																	}}
																>
																	Looks Good
																</XButtonConfirm>
															</Col>
															<Col
																xs={24}
																className="mt-4"
															>
																<XButtonConfirm
																	className="btnActive w-100"
																	loading={
																		coverageloading
																	}
																	onClick={() => {
																		setCoverageLoading(
																			true,
																		);
																		sendFeedback(
																			{
																				feedback_id:
																					feedbackId,
																				status: 'approved',
																				response:
																					pageContent.medicalCoverage,
																			},
																		);
																	}}
																	disabled={
																		pageContent.status ===
																		'approved'
																			? true
																			: false
																	}
																	type="primary"
																	shape="round"
																	// icon={
																	// 	<img
																	// 		src="/images/check 1.svg"
																	// 		alt=""
																	// 	/>
																	// }
																	size="large"
																>
																	Confirm
																	Coverage
																</XButtonConfirm>
															</Col>
														</Row>
													</div>
													<div className="showDesktop">
														<Row className="text-end">
															<Col
																xs={24}
																lg={12}
																className="mt-4"
															>
																<Space
																	style={{
																		width: '100%',
																	}}
																>
																	<XButtonConfirm
																		className="mb-2 mb-md-0 mb-sm-0"
																		type="primary"
																		size="large"
																		shape="round"
																		style={{
																			background:
																				'#fff',
																		}}
																		icon={
																			<img
																				className="rotateButton"
																				src="/images/like-icon.svg"
																				alt=""
																			/>
																		}
																		onClick={() => {
																			form.setFieldsValue(
																				{
																					modal_text_area:
																						pageContent.medicalCoverage
																							? pageContent
																									.medicalCoverage[1]
																							: '',
																					medicare_flag:
																						pageContent.medicalCoverage
																							? pageContent
																									.medicalCoverage[0]
																							: '',
																				},
																			);
																			setModalTextArea(
																				pageContent
																					.medicalCoverage[1],
																			);
																			setModalOpen(
																				[
																					true,
																					`Edit Medicare Coverage`,
																					pageContent
																						.medicalCoverage[1],
																					1,
																					'feedbackSummary',
																				],
																			);
																		}}
																	>
																		Refine
																	</XButtonConfirm>
																	<XButtonConfirm
																		className="mb-2 mb-md-0 mb-sm-0"
																		type="primary"
																		size="large"
																		shape="round"
																		style={{
																			background:
																				'#fff',
																		}}
																		icon={
																			<img
																				src="/images/like-icon.svg"
																				alt=""
																			/>
																		}
																		loading={
																			LooksGoodLoading
																		}
																		onClick={() => {
																			setLooksGoodLoading(
																				true,
																			);
																			sendFeedback(
																				{
																					feedback_id:
																						feedbackId,
																					feedback:
																						'positive',
																					status: 'approved',
																					response:
																						pageContent.medicalCoverage,
																				},
																			);
																		}}
																	>
																		Looks
																		Good
																	</XButtonConfirm>
																</Space>
															</Col>
															<Col
																xs={24}
																lg={12}
																className="mt-4 text-md-end"
															>
																<XButtonConfirm
																	loading={
																		coverageloading
																	}
																	onClick={() => {
																		setCoverageLoading(
																			true,
																		);
																		sendFeedback(
																			{
																				feedback_id:
																					feedbackId,
																				status: 'approved',
																				response:
																					pageContent.medicalCoverage,
																			},
																		);
																	}}
																	disabled={
																		pageContent.status ===
																		'approved'
																			? true
																			: false
																	}
																	type="primary"
																	shape="round"
																	// icon={
																	// 	<img
																	// 		src="/images/check 1.svg"
																	// 		alt=""
																	// 	/>
																	// }
																	size="large"
																	className="btnActive"
																>
																	Confirm
																	Coverage
																</XButtonConfirm>
															</Col>
														</Row>
													</div>
												</>
											)
										) : (
											<></>
										)}
									</Col>
								</>
							)}
						</Row>

						{/* //todo Drawer of the Coding Tools Start */}
						<XAddCodeSticky
							type="primary"
							onClick={showIcdCptDrawer}
						>
							Coding Tools
						</XAddCodeSticky>

						{/* // todo coding tools */}
						<DrawerCodingTools
							// previewMode={false}
							activeTab={activeTab}
							setActiveTab={setActiveTab}
							openIcdDrawer={openIcdDrawer}
							setOpenIcdDrawer={setOpenIcdDrawer}
							openCptDrawer={openCptDrawer}
							setOpenCptDrawer={setOpenCptDrawer}
							previewMode={caseClosed}
							fixed={false}
							icdform={icdform}
							cptform={cptform}
							activeCode={activeCode}
							setActiveCode={setActiveCode}
							closeIcdCptDrawer={closeIcdCptDrawer}
							openIcdCptDrawer={openIcdCptDrawer}
							handleCodeClick={handleCodeClick}
							setModalOpen={setModalOpen}
							setModalTextArea={setModalTextArea}
							closeIcdCptDrawer2={closeIcdCptDrawer2}
							openIcdCptDrawer2={openIcdCptDrawer2}
							modalOpen={modalOpen}
							updatePageContent={updatePageContent}
							modalTextArea={modalTextArea}
							setIcdCodes={setIcdCodes}
							icdCodes={icdCodes}
							searchResults={searchResults}
							setSearchResults={setSearchResults}
							icdLoading={icdLoading}
							setIcdLoading={setIcdLoading}
							triggeredBySearch={triggeredBySearch}
							setTriggeredBySearch={setTriggeredBySearch}
							triggeredByEnter={triggeredByEnter}
							setTriggeredByEnter={setTriggeredByEnter}
							loadMore={loadMore}
							setLoadMore={setLoadMore}
							icdSearchLoading={icdSearchLoading}
							setIcdSearchLoading={setIcdSearchLoading}
							cptCodes={cptCodes}
							setCptCodes={setCptCodes}
							cptLoading={cptLoading}
							setCptLoading={setCptLoading}
							cptSearchResults={cptSearchResults}
							setCptSearchResults={setCptSearchResults}
							cptTriggeredBySearch={cptTriggeredBySearch}
							setCptTriggeredBySearch={setCptTriggeredBySearch}
							cptTriggeredByEnter={cptTriggeredByEnter}
							setCptTriggeredByEnter={setCptTriggeredByEnter}
							cptLoadMore={cptLoadMore}
							setCptLoadMore={setCptLoadMore}
							cptSearchLoading={cptSearchLoading}
							setCptSearchLoading={setCptSearchLoading}
							icdFilters={icdFilters}
							setIcdFilters={setIcdFilters}
							cptFilters={cptFilters}
							setCptFilters={setCptFilters}
						/>
						{/* // todo coding tools */}
					</>
				) : (
					<Result
						status="403"
						title="403"
						subTitle="Sorry, you are not authorized to access this page."
						extra={
							<Button
								type="primary"
								onClick={() => navigate('/')}
							>
								Back Home
							</Button>
						}
					/>
				)}
			</XContainer>

			{/* Modal for preview */}
			<XThemeModal
				open={previewOpen}
				title={previewTitle}
				footer={null}
				onCancel={handleCancel}
			>
				{previewImage ? (
					<img
						alt="example"
						style={{
							width: '100%',
						}}
						src={previewImage}
					/>
				) : null}
			</XThemeModal>
			<XThemeModal
				open={pdfPreviewOpen}
				title="Preview"
				footer={null}
				onCancel={() => setPdfPreviewOpen(false)}
				width={700} // Set the width of the modal dynamically
			>
				<div>
					<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js">
						<div
							style={{
								height: '750px',
							}}
						>
							<Viewer fileUrl={previewImage} />
						</div>
					</Worker>
				</div>
			</XThemeModal>

			{/* Modal for adding new option */}
			<XThemeModal
				// title="Add New Option"
				title={
					<>
						<span className="modalTitleIcon">
							<img src="/images/add-modal-icon.svg" alt="Add" />
						</span>
						Add New Option
					</>
				}
				okButtonProps={{
					className: 'xThemeButtonSubmit',
				}}
				cancelButtonProps={{
					className: 'xThemeCancelSubmit',
				}}
				open={newCheckBoxModal[0]}
				onOk={handleNewCheckBoxModal}
				okText="Submit"
				onCancel={() => {
					setNewCheckBoxModal([false, null]);
					setNewOptionText('');
					newOptionForm.setFieldsValue({});
					newOptionForm.resetFields();
				}}
			>
				<XForm
					form={newOptionForm}
					name="groupForm"
					layout="vertical"
					autoComplete="off"
				>
					<XForm.Item
						name={'new-option'}
						rules={[
							{
								required: true,
								message: 'Please input option',
							},
						]}
					>
						<XThemeInputText
							className="my-3 largeInputForms"
							size="large"
							value={newOptionText}
							onChange={(e) => setNewOptionText(e.target.value)}
							placeholder="Enter new option text"
						/>
					</XForm.Item>
				</XForm>
			</XThemeModal>

			<XThemeModal
				centered
				open={thanksModal[0]}
				closable={false} // Hide the close icon
				// onOk={() => setThanksModal([false, ''])}
				// onCancel={() => {
				// 	setThanksModal([false, '']);
				// }}
				className="modalButton"
				okText="Submit"
				footer={null}
			>
				<Row
					style={{
						display: 'flex',
						justifyContent: 'center',
					}}
					gutter={(15, 0)}
					className="mt-2"
				>
					<Col xs={24} lg={18}>
						<XLottieMargin>
							<XLottie animationData={Thanks} loop={true} />
						</XLottieMargin>

						<XPara1
							style={{ textAlign: 'center' }}
							className="mt-0"
						>
							{thanksModal[1]}
						</XPara1>
					</Col>
				</Row>
			</XThemeModal>
		</>
	);
};

const mapStateToProps = (state) => ({
	analyseCoverageState: state.analyseCoverage,
	reviseCoverageState: state.reviseCoverage,
	sendFeedbackState: state.sendFeedback,
	getAnalysisState: state.getAnalysis,
	editCaseState: state.editCase,
	getIcdCodesState: state.getIcdCodes,
	getCptCodesState: state.getCptCodes,
});

const mapDispatchToProps = (dispatch) => ({
	analyseCoverage: (params) => dispatch(analyseCoverageApi(params)),
	analyseCoverageReset: () => dispatch(analyseCoverageReset()),
	reviseCoverage: (params) => dispatch(reviseCoverageApi(params)),
	reviseCoverageReset: () => dispatch(reviseCoverageReset()),
	sendFeedback: (params) => dispatch(sendFeedbackApi(params)),
	sendFeedbackReset: () => dispatch(sendFeedbackReset()),
	getAnalysis: (params) => dispatch(getAnalysisApi(params)),
	getAnalysisReset: () => dispatch(getAnalysisReset()),
	editCase: (data) => dispatch(editCaseApi(data)),
	editCaseReset: () => dispatch(editCaseReset()),
	getIcdCodes: (data) => dispatch(getIcdCodesApi(data)),
	getIcdCodesReset: () => dispatch(getIcdCodesReset()),
	getCptCodes: (data) => dispatch(getCptCodesApi(data)),
	getCptCodesReset: () => dispatch(getCptCodesReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseAnalysisView);
